<script lang="ts" setup>
defineProps<{
  icon: string
  name: string
}>()
</script>

<template>
  <a
    class="
      flex items-center rounded-xl bg-[#e5e5e5] px-3
      py-2.5 text-sm leading-[1.71] text-main-dark !no-underline
      sm:rounded-2xl
    "
    href="#"
  >
    <SvgIcon class="!size-5 sm:!size-6" :name="icon" />

    <span class="capitalize-first-letter ml-1 block text-sm sm:text-base">
      {{ name }}
    </span>
  </a>
</template>

<style lang="scss" scoped>
.capitalize-first-letter::first-letter {
  text-transform: uppercase;
}
</style>
